import { createElement } from "../../util/element"

import { faAngleRight, faCircleNotch, faAngleDown } from '@fortawesome/pro-solid-svg-icons'
import { icon } from '@fortawesome/fontawesome-svg-core'

import { listen } from 'ol/events';
import { unByKey } from 'ol/Observable';

class TreeComboBoxEntry {
	constructor(options) {
		const { node, container, updateContainerSize } = options;
		
		this.node = node;
		this.updateContainerSize = updateContainerSize;
				
		this.element = createElement("li", undefined, container);
		this.expand = createElement("a");
		this.selector = createElement("a");
		
		this.childNodes = [];
		
		if( node == null ) {
			this.initEntry();
		} else {
			this.element.appendChild( icon( faCircleNotch ).node[0] );		
			this.loadChildren(node);
		}
	
		this.expand.addEventListener("click", this.handleExpandClick.bind(this), false);
		this.selector.addEventListener("click", this.handleSelectClick.bind(this), false);
	}
	
	handleExpandClick(event) {
        this.displayChildren();        
        event.stopPropagation();
	}
	
	handleSelectClick(event) {
		if( !this.node.enabled ) {
            this.displayChildren();
        } else {
            this.node.select();
        }
        
        event.stopPropagation();
	}
	
	async loadChildren(node) {
		const { children } = node;
		let values = undefined;
		
		if( typeof children === 'function' ) {
			values = await children();
		} else if( Array.isArray(children) ) {
			values = children;
		} else {
			console.warn("invalid type: ", children);
			values = [];
		}
		
		values.forEach( value => this.childNodes.push(value) );
		
		this.initEntry();
	}
	
	initEntry() {
		this.element.replaceChildren();

		const container = createElement("div", "tree-combobox-option", this.element);
		const node = this.node;
				
        if( !node.enabled ) {
			this.selector.disabled = true;
			container.classList.add("disabled");
		}
		
		if( this.childNodes.length > 0 ) {		
			this.expand.appendChild(icon( faAngleRight ).node[0]);	
			this.expand.classList.add("icon");
			
			container.appendChild(this.expand);
		} else {
			this.selector.classList.add( "leaf" );
		}
		
		if( typeof node.label === 'function') {
        	this.selector.innerHTML = node.label( this.childNodes.length == 0 );
		} else  {
            this.selector.innerHTML = node.label;
		}

		container.appendChild(this.selector);
		              
        if( node.open && this.childNodes.length > 0 ) {
            this.displayChildren();
        } else if( node.active ) {
            container.classList.add("selected");

			const registration = listen(document.body, "mousemove", event => {
				if( !this.element.contains(event.target) ) {
					removeHandler();
				}
			} );
			
			const removeHandler = () => {
				unByKey(registration);
            	container.classList.remove("selected");
			}        
        }
        
        this.updateContainerSize();		
	}
	
	displayChildren() {
		this.expand.replaceChildren();
		
		if( this.children != null ) {
			this.children.parentNode.removeChild(this.children);
			this.children = null;
			
			this.expand.appendChild(icon( faAngleRight ).node[0]);	
		} else {
			this.children = createElement("li", undefined, this.element);
			
			this.childNodes.forEach(node => new TreeComboBoxEntry({
				node: node,
				container: this.children,
				updateContainerSize: this.updateContainerSize
		     }));
		     
			this.expand.appendChild(icon( faAngleDown ).node[0]);	
		}
	}
}

export { TreeComboBoxEntry }